import React from "react";
import { ReactComponent as ResearchIcon } from "assets/icons/landing_research.svg";
import { ReactComponent as OrganizeIcon } from "assets/icons/landing_organize.svg";
import { ReactComponent as AnalyzeIcon } from "assets/icons/landing_analyze.svg";
import { useNavigate } from "react-router";

const HowItWorksSection = () => {
  const navigation = useNavigate();

  return (
    <div className="h-[359px] pt-[25px]">
      <div className="mx-auto max-w-[1320px] desktop:px-0  xl:px-6 px-0">
        <h1 className="text-[30px] px-5 xl:px-0 text-center md:text-start md:text-[40px] font-semibold leading-[1.2] md:leading-[48.41px] text-black">
          Come <span className="font-bold text-primary">funziona</span>
        </h1>
        <div className="flex items-center pt-[25px] pb-4 gap-x-[22px] xl:px-0 px-5 overflow-x-scroll xl:overflow-visible scroll-smooth scrollbar-hide ">
          <div
            onClick={() => navigation("/research")}
            className="min-w-[320px] w-full border-[1.5px] border-[#F2F4F6] h-[214px] transition-all duration-300 ease-in-out how-it-work-card-hover rounded-[10px] px-[21px]  pt-[23px] flex flex-col items-center"
          >
            <ResearchIcon className="w-[60px] h-[55px] " />
            <h3 className="mt-[12px] leading-[29.05px] text-primary font-bold text-[24px] text-center">
              Ricerca
            </h3>
            <p className="font-normal mt-[11px] text-[14px] text-center leading-normal md:leading-[28px] text-black">
              Scannerizza centinaia di annunci immobiliari su tutte le
              piattaforme con una sola ricerca
            </p>
          </div>
          <div
            onClick={() => navigation("/organizer")}
            className="min-w-[320px] w-full h-[214px] transition-all duration-300 ease-in-out border-[1.5px] how-it-work-card-hover border-[#F2F4F6] rounded-[10px] px-[21px] pt-[23px] flex flex-col items-center"
          >
            <OrganizeIcon className="w-[60px] h-[55px] " />
            <h3 className="mt-[12px] leading-[29.05px] text-primary font-bold text-[24px] text-center">
              Organizza
            </h3>
            <p className="font-normal mt-[11px] text-[14px] text-center leading-normal md:leading-[28px] text-black">
              Salva gli annunci e crea liste personalizzate e condivise, tutto
              in un unico posto
            </p>
          </div>
          <div
            onClick={() => navigation("/dashboard")}
            className=" min-w-[320px] w-full transition-all duration-300 ease-in-out how-it-work-card-hover  h-[214px] border-[1.5px] border-[#F2F4F6] rounded-[10px] px-[21px] pt-[23px] flex flex-col items-center"
          >
            <AnalyzeIcon className="w-[60px] h-[55px] " />
            <h3 className="mt-[12px] leading-[29.05px] text-primary font-bold text-[24px] text-center">
              Analizza
            </h3>
            <p className="font-normal mt-[11px] text-[14px] text-center leading-normal md:leading-[28px] text-black">
              Esamina gli immobili con dati e analisi approfondite per scelte
              immobiliari redditizie
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksSection;
